import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../../lib/connect/clients';
import { accessDenied } from './outputPresentationModel';
export const outputsKey = (id)=>[
        'capture-outputs',
        id
    ];
export const snapshotsKey = (id)=>[
        'capture-output-snapshots',
        id
    ];
const retry = (count, error)=>!accessDenied(error) && count < 1;
export function useCaptureOutputs(captureProjectId, templateId) {
    return useQuery({
        queryKey: [
            ...outputsKey(captureProjectId),
            templateId
        ],
        queryFn: ()=>projectDataClient.getCaptureOutputs({
                captureProjectId,
                templateId
            }),
        retry
    });
}
export function useOutputSnapshots(captureProjectId) {
    return useQuery({
        queryKey: snapshotsKey(captureProjectId),
        queryFn: ()=>projectDataClient.listCaptureOutputSnapshots({
                captureProjectId
            }),
        retry
    });
}
